module.exports = __webpack_public_path__ + "img/wjy.9de376e7.png";